<template>
  <v-content v-if="!success">
    <v-container fill-height>
      <v-layout align-center justify-center class="signin_layout">
        <div class="signin_box_wrapper">          
          <div class="signin_box_img"></div>
          <div class="signin_box">
            <div class="signin_header">
              <img src="@/assets/img/bici/logo.png" width="40"/>
              <div class="signin_title">
                <small>China1 | HCCP</small>
                <span>Sign In to user account</span>
              </div>
            </div>
            <div class="input_fields">
              <v-text-field 
                v-model="username" 
                name="signin" 
                label="Email" 
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="password"   
                outlined          
                id="password"
                name="password"
                label="Password"
                type="password"
                @keyup.enter="handleSubmit()"
              ></v-text-field>
              <!-- <v-text-field
                v-model="otpCode"   
                name="otpCode"
                label="Otp Code"
                type="text"
                :rules="otpRules"
                maxlength="6"
                @keyup.enter="handleSubmit()"
                disabled
              ></v-text-field> -->
            </div>
            <div class="forgot"><router-link to="/Forgot">Forgot Password?</router-link></div>
            <div v-bind:style="incorrect" class="incorrect">{{errMsg}}</div>
            <div class="button_wrapper">
              <v-btn color="warning" @click="handleSubmit()">Sign-In</v-btn>
            </div>
            
            <div class="register">
              <span @click="downloadPDF" title="How to Account Register Guidance"><img src="@/assets/img/icon/help.svg"/></span>
              Click here to <router-link to="/register">Get Permission</router-link></div>
            <div class="description">
              Optimized for viewing in 
              <a href="https://www.google.com/chrome/?brand=CHBD&gclid=CjwKCAjwiMj2BRBFEiwAYfTbClJ4Iht0So5ri1TexRLdt6qK6Z_26bkFyF3nyzLsIvC_RYWydvVAuBoCgp8QAvD_BwE&gclsrc=aw.ds" target="_blank">
              Chrome
              </a>
              <br>to provide better reporting service.
            </div>     
          </div>
        </div>
      </v-layout>
      <!-- OTP 등록 다이얼로그 -->
      <v-dialog v-model="otpRegVisible" persistent max-width="600px">
        <otp-reg 
          :userName="username"
          @otpRegisterSuccess="handleOtpRegisterSuccess"
          @otpRegisterNewCancel="handleOtpRegisterNewCancel"
          @otpRegisterCancel="handleOtpRegisterCancel">

        </otp-reg>
      </v-dialog>
      <!-- 비밀번호 재설정 다이얼로그 -->
      <v-dialog v-model="passwordResetVisible" persistent max-width="600px">
        <password-reset 
          :visible="passwordResetVisible"
          :account="account"
          @passwordResetSuccess="handlePasswordResetSuccess"
          @passwordResetCancel="handlePasswordResetCancel"
          @passwordResetForgot="handlePasswordResetForgot">
        </password-reset>
      </v-dialog>
    </v-container>
  </v-content>
</template>

<script>
import '@/assets/stylus/ui/component/_signin.styl'

import { mapState, mapActions } from 'vuex'
import __C from '../primitives/_constant_'
import ServiceRoutes from '@/mixins/service.routers.mixin'
import OtpReg from './OtpReg.vue'
import PasswordReset from './PasswordReset.vue'

export default {
  name: 'signin',
  mixins: [
    ServiceRoutes
  ],
  components: {
    OtpReg,
    PasswordReset
  },
  data: () => ({
    otpCode: '999999', // 사용자 입력 OTP 코드
    otpRegVisible: false, // 다이얼로그 표시 여부
    passwordResetVisible: false, // 비밀번호 재설정 팝업 표시 여부
    errMsg: '',
    accountService: null,
    username: '',
    password: '',
    submitted: false,
    success: false,
    incorrect: {
      visibility: 'hidden'
    },
    otpRules: [
      v => !!v || 'OTP is required', // 필수 입력 검사
      v => /^\d{6}$/.test(v) || 'OTP must be exactly 6 digits', // 6자리 숫자 검사
    ],
  }),
  created() {
    this.success = false
  },
  watch: {
    username(v) {
      if (v == '') {
        this.incorrect.visibility='hidden'
      }
    },
    password(v) {
      if (v == '') {
        this.incorrect.visibility='hidden'
      }
    },
    otpCode(v) {
      if (v == '') {
        this.incorrect.visibility='hidden'
      }
    }
  },
  computed: {
    ...mapState(__C.STORE_NAMESPACE.ACCOUNT, ['status']),
    ...mapState(__C.STORE_NAMESPACE.ACCOUNT, ['account']),
  },
  methods: {
    ...mapActions(__C.STORE_NAMESPACE.ACCOUNT, ['signin', 'signout']),
    ...mapActions(__C.STORE_NAMESPACE.APPLICATION, ['initialize']),

    async handleSubmit() {
      this.submitted = true
      const { username, password,otpCode } = this

      // 비밀번호를 SHA-256으로 해싱
      const passwordBuffer = new TextEncoder().encode(password)
      const hashedPasswordBuffer = await crypto.subtle.digest('SHA-1', passwordBuffer)
      const hashedPassword = this.arrayBufferToHex(hashedPasswordBuffer).toUpperCase()
      // password = hashedPassword
      // console.log('hashedPassword', hashedPassword)
      this.signin({ username, password:hashedPassword, otpCode }).then(success => {
        if(!success.error) {
          
          const {otpUseYN, otpRegYN,tmpPasswdYN='N' } = success
          // OTP 사용 여부와 등록 여부 확인

          if (otpUseYN === 'Y' && otpRegYN === 'N') {
            // OTP 등록이 필요할 때 OTP 등록 창을 띄움
            this.otpRegVisible = true
          } else if (tmpPasswdYN === 'Y') {
            // 비밀번호 변경이 필요한 경우 팝업 표시
            this.passwordResetVisible = true
          } else {
            // OTP 등록이 완료된 경우 로그인 성공 처리
            this.initialize().then(navItems => {
              this.setServiceRouter(navItems)
              this.$router.replace('/', () => {})
              this.incorrect.visibility = 'hidden'  // 오류 메시지 숨기기
            })
          }
        } else{
          this.incorrect.visibility='visible'
          this.errMsg = success.message
        }
      })
    },

    handlePasswordResetSuccess() {
      // 비밀번호 변경 성공 후 처리
      //this.resetTmpPasswdFlag({ newPassword }).then(() => {
      if (this.$route.path !== '/signin') {
        this.$router.replace('/signin').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        });
      }      
      localStorage.removeItem(__C.LOCAL_STORAGE_NAME.ACCOUNT)
      this.incorrect.visibility = 'hidden'  // 오류 메시지 숨기기
      this.passwordResetVisible = false
      //})
    },
    handlePasswordResetCancel() {
      // 비밀번호 변경없이 취소
      //this.resetTmpPasswdFlag({ newPassword }).then(() => {
      if (this.$route.path !== '/signin') {
        this.$router.replace('/signin').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
      localStorage.removeItem(__C.LOCAL_STORAGE_NAME.ACCOUNT)
      this.incorrect.visibility = 'hidden'  // 오류 메시지 숨기기
      this.passwordResetVisible = false
      //})
    },
    handlePasswordResetForgot() {
      // resend code
      //this.resetTmpPasswdFlag({ newPassword }).then(() => {
      localStorage.removeItem(__C.LOCAL_STORAGE_NAME.ACCOUNT)
      this.incorrect.visibility = 'hidden'  // 오류 메시지 숨기기
      this.passwordResetVisible = false
      // Forgot Password 페이지로 이동
      this.$router.push('/Forgot')
    },
    downloadPDF(){
      let link = document.createElement('a')
      link.href = `${__C.HOST_NAME}/resources/pdf/JGS_Account_Register_Guidance_ver1.0.pdf`
      // link.href = `${__C.HOST_NAME}/img/JGS_Account_Register_Guidance_ver1.0.pdf`
      document.body.appendChild(link)
      link.click()
    },

    handleOtpRegisterSuccess() {
      // OTP 등록 성공 후 처리
      this.initialize().then(navItems => {
        this.setServiceRouter(navItems)
        this.$router.replace('/', () => {})
        this.incorrect.visibility = 'hidden'  // 오류 메시지 숨기기
        this.otpRegVisible = false // 다이얼로그 닫기
      })
    },
    handleOtpRegisterNewCancel() {
      // OTP 등록전 취소 처리
      this.otpRegVisible = false
    },
    handleOtpRegisterCancel() {
      // OTP 등록후 취소 처리
      this.otpRegVisible = false
    },
    // Utility function to convert ArrayBuffer to hex string
    arrayBufferToHex(buffer) {
      return Array.from(new Uint8Array(buffer))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('')
    }
  }
}
</script>